<template>
    <Dropdown>
        <span class="cursor-pointer">
            <CIcon file="language.svg" class="text-20"></CIcon>
        </span>
        <template v-slot:overlay>
            <Menu>
                <MenuItem @click="() => onClickLocale(l.value)" v-for="l in locales" :key="l.value">
                    <a href="javascript:void(0)">
                        <span>{{ l.title }}</span>
                        <CIcon file="check.svg" class="text-success ml-2" v-if="l.value === stateApp.locale"></CIcon>
                    </a>
                </MenuItem>
            </Menu>
        </template>
    </Dropdown>
</template>

<script>
import { defineAsyncComponent, defineComponent } from "vue";
import { state as stateApp } from "../../../app.logic";
import { Dropdown, Menu } from "ant-design-vue";
import { locales, onClickLocale } from "./app-layout.logic";

export default defineComponent({
    components: {
        Dropdown,
        Menu,
        MenuItem: Menu.Item,
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon")),
    },
    setup() {
        return { stateApp, locales, onClickLocale };
    },
});
</script>
